import { useMutation, useQueryClient, UseMutationResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstance";
import { enum_api_uri } from "../utils/enum";

interface PutAdminAccountRequest {
    idx: number | string;
    a_pwd?: string;
    a_name?: string;
}

interface PutAdminAccountResponse {
    statusCode: number;
    message: string;
    data: { idx: number };
}

export const usePutConsoleAdminAccount = (): UseMutationResult<PutAdminAccountResponse, Error, PutAdminAccountRequest> => {
    const queryClient = useQueryClient();

    return useMutation<PutAdminAccountResponse, Error, PutAdminAccountRequest>({
        mutationFn: async ({ idx, ...body }) => {
            const url = enum_api_uri.put_console_admin_account.replace(":idx", String(idx));
            const response = await axiosInstance.put(url, body);
            return response.data;
        },
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({ queryKey: ["useGetConsoleAdminAccounts"] });
            queryClient.invalidateQueries({ queryKey: ["useGetConsoleAdminAccount", variables.idx] });
        },
    });
};
